export const EXTERNAL_SVG = "assets/external.svg";
export const CLOSE_SVG = "assets/close.svg"; 
export const RIGHT_ARROW_SVG = "assets/right-arrow.svg";
export const EXTERNAL_BLACK_SVG = "assets/external-black.svg";
export const SORT_SVG = "assets/sort.svg";

export const TRIGGER_AUTO_ICON = "icon ms-Icon ms-Icon--TriggerAuto";
export const DELETE_ICON = "icon node-icon ms-Icon ms-Icon--Delete";